export const SignOut = () => {
  localStorage.removeItem('merchant')
  localStorage.removeItem('user')
  localStorage.removeItem('token')
  localStorage.removeItem('hubspot-jwt')
  ;(window as any).HubSpotConversations?.clear?.({ resetWidget: true })
  ;(window as any).HubSpotConversations?.widget?.remove?.()
  ;(window as any).hsConversationsSettings = {
    loadImmediately: false
  }
}
